import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import OsgopDTO from '../../../../dto/OsgopDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';

export default function OsgopForm(props) {
  const { control, formMeta } = props;
  const dto = new OsgopDTO();
  const attributes = dto.getAttributesByName();

  return (
    (
      <>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.carrier_external_id}
            variant="material"
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.vehicle_osgop_number}
            variant="material"
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            onChangeToIso
            withLabel
            hideTime
            dtoObject={attributes.vehicle_osgop_valid_from_date}
            variant="material"
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            onChangeToIso
            withLabel
            hideTime
            dtoObject={attributes.vehicle_osgop_valid_until_date}
            variant="material"
          />
        </Row>
      </>
    )
  );
}
